var map = {
	"./views/AboutView": [
		8162,
		741,
		242,
		634,
		371
	],
	"./views/AboutView.vue": [
		8162,
		741,
		242,
		634,
		371
	],
	"./views/ApiView": [
		4051,
		51
	],
	"./views/ApiView.vue": [
		4051,
		51
	],
	"./views/BlockChainsView": [
		6866,
		866
	],
	"./views/BlockChainsView.vue": [
		6866,
		866
	],
	"./views/CreditAnalysisView": [
		9549,
		549
	],
	"./views/CreditAnalysisView.vue": [
		9549,
		549
	],
	"./views/CreditEvaluateView": [
		8873,
		873
	],
	"./views/CreditEvaluateView.vue": [
		8873,
		873
	],
	"./views/CultureDetailView": [
		5793,
		741,
		128
	],
	"./views/CultureDetailView.vue": [
		5793,
		741,
		128
	],
	"./views/CultureView": [
		6283,
		741,
		242,
		586,
		283
	],
	"./views/CultureView.vue": [
		6283,
		741,
		242,
		586,
		283
	],
	"./views/DemoView": [
		5195,
		741,
		357
	],
	"./views/DemoView.vue": [
		5195,
		741,
		357
	],
	"./views/DigitalBrain": [
		5985,
		985
	],
	"./views/DigitalBrain.vue": [
		5985,
		985
	],
	"./views/DigitalInvestmentView": [
		4339,
		288,
		614
	],
	"./views/DigitalInvestmentView.vue": [
		4339,
		288,
		614
	],
	"./views/HomeView": [
		3839,
		288,
		963
	],
	"./views/HomeView.vue": [
		3839,
		288,
		963
	],
	"./views/JoinUsView": [
		7794,
		741,
		242,
		586,
		634,
		899
	],
	"./views/JoinUsView.vue": [
		7794,
		741,
		242,
		586,
		634,
		899
	],
	"./views/NewsDetailView": [
		7307,
		741,
		784
	],
	"./views/NewsDetailView.vue": [
		7307,
		741,
		784
	],
	"./views/NewsView": [
		9630,
		741,
		242,
		586,
		630
	],
	"./views/NewsView.vue": [
		9630,
		741,
		242,
		586,
		630
	],
	"./views/PolicyServicesView": [
		6606,
		606
	],
	"./views/PolicyServicesView.vue": [
		6606,
		606
	],
	"./views/ProductView": [
		2431,
		431
	],
	"./views/ProductView.vue": [
		2431,
		431
	],
	"./views/PsSearchNewView": [
		7111,
		111
	],
	"./views/PsSearchNewView.vue": [
		7111,
		111
	],
	"./views/SmallEntServeView": [
		2210,
		288,
		673
	],
	"./views/SmallEntServeView.vue": [
		2210,
		288,
		673
	],
	"./views/SupplyChainsView": [
		1049,
		49
	],
	"./views/SupplyChainsView.vue": [
		1049,
		49
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9331;
module.exports = webpackAsyncContext;